// extracted by mini-css-extract-plugin
export default {"tooltip":"US-z","arrow":"VS-z"};